// removed by extract-text-webpack-plugin
module.exports = {"header":"_2RwblXlW5YqARbjTQrATus","active":"_2J5dBrXeiPM88Lko2ylmxB","line":"pbcrUemTnb9aXo_FeZXea"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GoeasyTabBar/GoeasyTabBar.scss
 ** module id = 974
 ** module chunks = 0
 **/